import {
  trackEvent
} from "./helpers";

jQuery(() => {
  initPage();
});

async function initPage() {
  jQuery('nav.main-menu a').on('click', async function(event) {
    event.preventDefault();

    const url = jQuery(this).attr('href');
    if(url.length === 0 || url == "#") {
      return;
    }

    const isNewTabClick = event.ctrlKey || event.metaKey || event.button === 1;
    const pageName = jQuery(this).find('span').html();


    trackEvent("PAGE_VIEW", pageName).finally(() => {
      if (isNewTabClick) {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    });
  });
}
